/**
 * html转义
 * @param {*} str
 */
export function unescapeHTML(str) {
  if (str.length === 0) return '';
  str = `${str}`;
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ');
}
/**
 * 递归处理关键字颜色高亮显示
 * @param {*} str
 * @param {*} keyword
 * @param {*} url
 */
export const wrapKeyWord = (str, keyword) => {
  if (keyword === '') return;
  let index = str.indexOf(keyword),
    last,
    next,
    strLength = index + keyword.length;
  if (index === -1) {
    return str;
  }
  last = str.substr(0, strLength);
  next = str.substr(strLength);

  return last.replace(keyword, '<b>' + keyword + '</b>') + wrapKeyWord(next, keyword);
};
/**
 * 判断字符串有多少字母
 * @param {*} str
 */
export const getLetterLen = str => {
  let reg = /[a-zA-Z]/g;
  if (str.match(reg)) {
    return str.match(reg).length;
  } else {
    return 0;
  }
};
/**
 * 判断字符串有多少数字
 * @param {*} str
 */
export const getNumLen = str => {
  let reg = /[0-9]/g;
  if (str.match(reg)) {
    return str.match(reg).length;
  } else {
    return 0;
  }
};



// WEBPACK FOOTER //
// ./src/utils/tools/str.js